import { render, staticRenderFns } from "./AdminComposeMessage.vue?vue&type=template&id=6cbf3987&scoped=true"
import script from "./AdminComposeMessage.vue?vue&type=script&lang=js"
export * from "./AdminComposeMessage.vue?vue&type=script&lang=js"
import style0 from "./AdminComposeMessage.vue?vue&type=style&index=0&id=6cbf3987&prod&lang=scss&scoped=true"
import style1 from "./AdminComposeMessage.vue?vue&type=style&index=1&id=6cbf3987&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf3987",
  null
  
)

export default component.exports